import AuthService from 'services/Auth/AuthService';
import { axiosInstance } from './axios';
import { graphQLService } from './graphQLService';
import config from 'src/config';

export const authService = new AuthService(axiosInstance, graphQLService, config);
authService.onClientChange(clientId => graphQLService.setClientId(clientId));
